import update from 'immutability-helper'
import { LOGIN, LOGIN_OUT } from '../constants'

let session = null
const value = localStorage.getItem('userMsg') || ''
if (value && value !== 'null' && value !== 'undefined') {
  session = JSON.parse(value)
}

export default function (state = session, action: any) {
  switch (action.type) {
    case LOGIN:
      return update(state, {
        $set: action.info,
      })
    case LOGIN_OUT:
      return update(state, {
        $set: {},
      })
    default:
      return state
  }
}
